import request from "@/utils/request";

// --- 登录相关 ---

// 发送短信验证码
export function sendSms(phone) {
  return request({
    url: "/login/SendBindMobileSms",
    method: "post",
    // baseURL: "https://eno.onechatai.cn/api",
    data: { phone },
  });
}

// 手机号登录
export function phoneLogin(data) {
  return request({
    url: "/login/PhoneLogin",
    method: "post",
    data, // { phone, smsCode }
  });
}

// --- 用户相关 ---

// 获取用户信息
export function getUserInfo() {
  return request({
    url: "/user/userInfo",
    method: "get",
  });
}

// 绑定微信
export function bingWechatInfo(code) {
  return request({
    url: `/user/BingWechatInfo?code=${code}`,
    method: "post",
  });
}

// --- 专注计时相关 ---

// 开始专注
export function startFocus() {
  return request({
    url: "/user/StartFocus",
    method: "post",
  });
}

// 专注心跳上报
export function pingFocus(sessionId) {
  return request({
    url: "/user/PingFocus",
    method: "post",
    data: { session_id: sessionId },
  });
}

// 完成专注
export function finishFocus(sessionId) {
  return request({
    url: "/user/FinishFocus",
    method: "post",
    data: { session_id: sessionId },
  });
}

// --- 订单与商品 ---

// 商品列表
export function getGoodsList() {
  return request({
    url: "/order/goods/list",
    method: "get",
  });
}

// 创建订单
export function createOrder(data) {
  return request({
    url: "/order/CreateOrder",
    method: "post",
    data,
    // {
    // "payment_way": "WeChatPay", //WeChatPay、Alipay
    // "payment_product": "H5", //H5(手机浏览器)、JSAPI(微信内打开网页)、NATIVE(pc网页扫码)、APP
    // "goods_id": 1
    // }
  });
}

// 查询订单状态
export function orderState(orderNo) {
  return request({
    url: `/order/OrderState?order_no=${orderNo}`,
    method: "get",
  });
}

// 微信支付配置
export function wechatPayAppConfig() {
  return request({
    url: "/order/WechatPayAppConfig",
    method: "get",
  });
}
